module.exports = __webpack_public_path__ + "static/dashboard_intro3_en@2x-6d6cd1da77d008a9c3b86b91cfef179d.png";